import { UndeleteBoardMutation, UndeleteBoardMutationVariables } from './__generated__/UndeleteBoardMutation'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UndeleteBoardMutation($boardId: String!) {
    undeleteBoard(input: { board: $boardId }) {
      id
    }
  }
`

export const useUndeleteBoard = () => useMutation<UndeleteBoardMutation, UndeleteBoardMutationVariables>(MUTATION)
